import React from 'react';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Map Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="map-fallback">
          <div className="map-fallback-icon">📍</div>
          <p className="map-fallback-text">
            Unable to load map
          </p>
          <p className="map-fallback-address">
            {this.props.property?.address || `${this.props.property?.city || 'Unknown Location'}${this.props.property?.state ? `, ${String(this.props.property.state)}` : ', India'}`}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MapErrorBoundary;














